import React from "react";
import { Doughnut } from "react-chartjs-2";

const DoughnutChart = ({
  labels,
  data,
  colors,
  centerLabel = "Total",
  centerValue = "",
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderWidth: 0,
        cutout: "70%", // controls the thickness of the ring
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };

  return (
    <div className="relative w-60 h-60">
      <Doughnut data={chartData} options={options} />
      <div className="absolute inset-0 flex flex-col items-center justify-center font-inter">
        <p className="text-[8px] text-black">{centerLabel}</p>
        <p className="text-4xl font-semibold">{centerValue}</p>
        <p className="text-white bg-[#1F4DFF]  font-normal text-xs px-3 py-1 rounded-[26px] mt-1 font-inter">
          ▲ $32 (2%)
        </p>
      </div>
    </div>
  );
};

export default DoughnutChart;
